export const API_URL = "https://smapi.layersshow.com/api";
